import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import OrderClientEntryPoints from '#app/entrypoints/orderClient';
import { useCollectionPaginated } from '#app/hooks/useCollectionPaginated';
import { Channel } from '#app/typings/channel';
import { OrderClientList, OrderClientState } from '#app/typings/orderClient';

type HookReturn = ReturnType<typeof useCollectionPaginated<OrderClientList, Filters>>;

export type Filters = {
  number?: string;
  numberCarrier?: string;
  email?: string;
  name?: string;
  numberSylius?: string;
  channels?: Channel[];
  orderClientStates?: OrderClientState[];
  carriers?: number[];
};

const useOrderClientList = (): HookReturn => {
  const { orderClientState } = useParams();
  const { setFilters, filters, ...props } = useCollectionPaginated<OrderClientList, Filters>(
    OrderClientEntryPoints.getCollection,
    {
      filters: {
        orderClientStates:
          orderClientState && Object.values(OrderClientState).includes(parseInt(orderClientState))
            ? [orderClientState as unknown as OrderClientState]
            : [],
      },
      sorting: {
        sortName: 'createdAt',
        sortDirection: 'desc',
      },
    },
  );

  useEffect(() => {
    setFilters({
      ...filters,
      orderClientStates:
        orderClientState && Object.values(OrderClientState).includes(parseInt(orderClientState))
          ? [orderClientState as unknown as OrderClientState]
          : [],
    });
  }, [orderClientState]);

  return {
    filters,
    setFilters,
    ...props,
  };
};

export default useOrderClientList;
